import useRollbarUtil from "@/components/hooks/useRollbarUtil";
import { AuthContext, AuthStatus } from "@/contexts/AuthContext";
import { useGetCompanyInfoQuery } from "@/generated/graphql";
import { useContext } from "react";

export const useCompanyInfo = () => {
  const { getNotifyErrorHandlerForGraphQL } = useRollbarUtil();
  const { authStatus } = useContext(AuthContext);

  const { data, loading, refetch } = useGetCompanyInfoQuery({
    skip: authStatus !== AuthStatus.SignedIn,
    onError: getNotifyErrorHandlerForGraphQL("error fetching company info"),
  });

  const companyInfo = data?.company;

  return {
    companyInfo,
    companyInfoLoading: loading,
    companyInfoRefetch: refetch,
  };
};
